import React, { Component, Fragment } from "react"
import { parse, isValid } from 'date-fns'

import Header from "../../components/Header/header"
import Sidebar from "../../components/Sidebar"
import { connect } from "react-redux"
import { Grid, Content } from '../../components/Layout'
import ContentHeader from "../../components/ContentHeader"

import { inventoryActions, productMapActions } from '../../actions'
import { ContentBody } from "../../components/ContentBody/ContentBody"
import styled from "styled-components"
import { DownloadButton, FormControl, InputMaskDate, Select } from "../../components/Form"
import { pxToRem } from "../../utils"
import iconPdf from '../../assets/icons/iconPdf.svg'
import iconExcel from '../../assets/icons/iconExcel.svg'
import { ptBR } from "date-fns/locale"

const WrapperSelect = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const WrapperButton = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const ActionButton = styled(DownloadButton)`
  margin: 10px;

  img {
    height: 14px;
    width: 14px;
    margin-right: 2px;
  }

  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const WarningWrapper = styled.div`
  color: #5b666d;
  min-height: ${pxToRem(240)};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    text-align: center;
  }
  strong {
    font-size: ${pxToRem(14)};
    text-align: center;
  }
`

const WrapperFilter = styled.div`
  width: 100%;
  padding-top: ${pxToRem('20px')};

  @media only screen and (max-width: 550px) {
    margin-bottom: ${pxToRem(18)};
  }
`

const Fields = styled.div`
  width: 100%;
  display: flex;
  margin-top: ${pxToRem(8)};
  flex-direction: row;

  @media only screen and (max-width: 550px) {
    flex-direction: column;

    > * {
      &:first-child {
        margin-bottom: ${pxToRem(24)};
      }
    }
  }

  &:first-child {
    margin-bottom: ${pxToRem(24)};
  }
`

const FilterTitle = styled.h2`
  width: 100%;
  margin: 0;
  font-size: ${pxToRem(16)};
`

const WrapperInputWithError = styled(FormControl)`
  padding: 0;
  width: 100%;
`

const InputError = styled.span`
  color: red;
  font-size: ${pxToRem(14)};
`

class HistoricReport extends Component {
	constructor(props) {
		super(props)
    this.state = {
			filters: {
        productId: '',
        initial_date: '',
        final_date: ''
      },
      errors: {
        initial_date: '',
        final_date: ''
      }
		}
	}

	componentWillReceiveProps(props) {
		if(this.props.areaId !== props.areaId) {
			this.props.fetchProductList(this.props.areaId)
		}
	}

	componentDidMount() {
    this.props.fetchProductList(this.props.areaId)
  }

	handleProduct = product => {
		this.setState(state => ({
			...state,
			filters: {
				...state.filters,
				productId: product.value,
        productName: product.label
			}
		}))
	}

	handleFilters = (field, value) => {
		this.setState(state => ({
			...state,
			filters: {
				...state.filters,
				[field]: value
			},
      errors: {
        ...state.errors,
        [field]: null
      }
		}))
	}

	productFullName = product => {
    let provider =
      product && product.provider && product.provider !== '---'
      ? ' - (' + product.provider + ')'
        : ''
    return product.name + provider
  }

  setErrorMessage = (field, message) => {
    this.setState(state => ({
      ...state,
      errors: {
        ...state.errors,
        [field]: message
      }
    }))
  }

  parseDate = (value) => {
    return parse(value, 'dd/MM/yyyy', new Date(), { locale: ptBR })
  }

  validDate = (field, date) => {
    const parsedDate = this.parseDate(date)

    if (!isValid(parsedDate)) {
      this.setErrorMessage(field, 'Data inválida')
      return false
    } else {
      this.setErrorMessage(field, null)
      return true
    }
  }

  isInitialBeforeFinal = (initial, final) => {
    const parsedInitialDate = this.parseDate(initial)
    const parsedFinalDate = this.parseDate(final)

    const validateInitialDate = this.validDate('initial_date', initial)
    const validateFinalDate = this.validDate('final_date', final)

    if (!validateInitialDate || !validateFinalDate) return false

    if (parsedInitialDate > parsedFinalDate) {
      this.setErrorMessage('initial_date', 'Data inicial deve ser anterior à data final')
      return false
    } 

    this.setErrorMessage('initial_date', null)
    return true
    
  }

  getDateFilters = (initial_date, final_date) => {
    const { validDate, isInitialBeforeFinal } = this

    if (initial_date.length > 0 && final_date.length > 0) {
      if (isInitialBeforeFinal(initial_date, final_date)) {
        return { initial_date, final_date }
      } else {
        return false
      }
    } else if (initial_date.length > 0) {
      if (validDate('initial_date',initial_date)) {
        return { initial_date }
      } else {
        return false
      }
    } else if (final_date.length > 0) {
      if (validDate('final_date', final_date)) {
        return { final_date }
      } else {
        return false
      }
    } 
    return true
  }

  downloadPdf = () => {
    const {
      productId,
      productName,
      initial_date,
      final_date
    } = this.state.filters

    const {areaId, fetchDownloadProductInventoryHistoricPDF} = this.props

    const { getDateFilters } = this

    let filtersParams = { areaId, productId, productName }

    const dateFilters = getDateFilters(initial_date, final_date)

    if (dateFilters) {
      filtersParams = { ...filtersParams, ...dateFilters }    
      fetchDownloadProductInventoryHistoricPDF(filtersParams)
    }
  }

  downloadXls = () => {
    const {
      productId,
      productName,
      initial_date,
      final_date
    } = this.state.filters

    const {areaId, fetchDownloadProductInventoryHistoricXLS} = this.props

    const { getDateFilters } = this

    let filtersParams = { areaId, productId, productName }

    const dateFilters = getDateFilters(initial_date, final_date)

    if (dateFilters) {
      filtersParams = { ...filtersParams, ...dateFilters }    
      fetchDownloadProductInventoryHistoricXLS(filtersParams)
    }
  }

	render() {
		const {
      areaId,
			router,
			productList,
			menuItems = [],
			last_update,
      loading
		} = this.props
		
		const { handleProduct, handleFilters, downloadPdf, downloadXls, productFullName } = this

		const { filters, errors } = this.state

		return (
			<Fragment>
				<Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />
					<Content>
						<ContentHeader
              title="Relatório de movimentação em estoque"
							subtitle="Entradas e saídas"
              last_update={last_update}
            />
            {areaId === 'all' ? (
              <WarningWrapper>
                <strong>Você deve selecionar uma área para acessar esta funcionalidade.</strong>
              </WarningWrapper>
            ) : (
              <ContentBody>
                <WrapperSelect>
                  <Select
                    placeholder="Todos os produtos"
                    onChange={value => {
                      handleProduct(value)
                    }}
                    options={productList.map(product => {
                      return {
                        label: productFullName(product),
                        value: product.id
                      }
                    })}
                  />
                  
                  <WrapperFilter>
                    <FilterTitle>Data de movimentação</FilterTitle>
                    <Fields>
                      <WrapperInputWithError>
                        <InputMaskDate
                          label={'Data Inicial'}
                          type={'text'}
                          value={filters.initial_date || ''}
                          onChange={event => {
                            handleFilters('initial_date', event.target.value)
                          }} 
                        />
                        {errors.initial_date && <InputError>{errors.initial_date}</InputError>}
                      </WrapperInputWithError>

                      <WrapperInputWithError>
                        <InputMaskDate
                          label={'Data Final'}
                          type={'text'}
                          value={filters.final_date || ''}
                          onChange={event => {
                            handleFilters('final_date', event.target.value)
                          }}
                        />
                        {errors.final_date && <InputError>{errors.final_date}</InputError>}
                      </WrapperInputWithError>
                    </Fields>
                  </WrapperFilter>
                </WrapperSelect>


                <WrapperButton>
                  <ActionButton
                    loading={loading}
                    onClick={
                      downloadPdf
                    }
                    disabled={loading || errors.final_date || errors.initial_date}
                  >
                    <img src={iconExcel} />PDF
                  </ActionButton>
                  <ActionButton
                    loading={loading}
                    onClick={
                      downloadXls
                    }
                    disabled={loading || errors.final_date || errors.initial_date}
                  >
                    <img src={iconPdf} />Excel
                  </ActionButton>
                </WrapperButton>
              </ContentBody>
            )}
					</Content>
				</Grid>
			</Fragment>
		)
	}
}


const mapStateToProps = state => ({
  areaId: state.auth.areaId,
  last_update: state.inventory.last_update,
  productList: state.productMap.items,
  loading: state.inventory.fetching.download
})

const mapDispatchToProps = dispatch => {
  return {
    fetchDownloadProductInventoryHistoricXLS: (params) => {
      dispatch(inventoryActions.fetchDownloadProductInventoryHistoricXLS(params))
    },
    fetchDownloadProductInventoryHistoricPDF: (params) => {
      dispatch(inventoryActions.fetchDownloadProductInventoryHistoricPDF(params))
    },
		fetchProductList: areaId => {
      dispatch(productMapActions.fetchCollectionProductsByInventory(areaId))
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(HistoricReport)


// WEBPACK FOOTER //
// ./src/containers/Inventory/HistoricReport.js